export default __webpack_public_path__ + "static/media/MinimumBuyError.32f2a2a5.png";